import { render, staticRenderFns } from "./ResetPassword-v1.vue?vue&type=template&id=119e73a4"
import script from "./ResetPassword-v1.vue?vue&type=script&lang=js"
export * from "./ResetPassword-v1.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword-v1.vue?vue&type=style&index=0&id=119e73a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports